import Service from "../../Service";
import Axios from "../../Config/API";
import { IOrigemLeadRepasse } from "../../../Interfaces/Repasse/OrigemLeadRepasse/OrigemLeadRepasseInterfaces";

export async function GetOrigemLeadService() {
    return Service(
        Axios.get<Array<IOrigemLeadRepasse>>(
            `vendas/origemlead/listarorigenslead`
        )
    );
}
